/*!
 * Free shipping bar
 * ---------------------------------------------------------------------------
 * 规则（哪个市场、哪个币种、门槛多少）已经由 Liquid 在服务端算好了，
 * 这个文件只做三件小事：
 *   1. 按购物车小计算出百分比，移动填充条
 *   2. 换文案（未满 / 快到了 / 已达成）
 *   3. 满额给元素加 .cart_shipping_free —— 卡车整体变绿、白圆保留、闪两下，
 *      全部由主题自带的 minicart.css 负责
 *
 * 不取任何接口去拿规则：以前那版用 fetch('/cart?section_id=...')，在主题
 * 编辑器里会拿到「已发布主题」的空结果，元素就被隐藏了 —— 抽屉里永远没有条。
 * 现在只在小计变化时读 /cart.js（纯购物车数据，不涉及主题渲染）。
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  var ZERO_DECIMAL = ['JPY', 'KRW', 'IDR', 'VND', 'CLP', 'ISK', 'TWD'];

  function bars() {
    return document.querySelectorAll('free-ship-bar');
  }

  /* ---------- formatting ------------------------------------------------ */

  function money(cents, currency) {
    currency = String(currency || '').toUpperCase();
    var val = (Number(cents) || 0) / 100;
    var digits = ZERO_DECIMAL.indexOf(currency) > -1 ? 0 : 2;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(val);
    } catch (e) {
      return currency + ' ' + val.toFixed(digits);
    }
  }

  function withTokens(text, amount, dest) {
    return String(text || '')
      .replace(/\{\s*amount\s*\}/gi, amount)
      .replace(/\{\s*dest\s*\}/gi, dest || '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  /* ---------- visibility ------------------------------------------------ */

  function wrapOf(el) {
    return el.closest ? el.closest('.fsb-drawer-wrap') : null;
  }

  function hide(el) {
    el.classList.add('fsb-hidden');
    var wrap = wrapOf(el);
    if (wrap) wrap.classList.add('fsb-wrap-hidden');
  }

  function show(el) {
    el.classList.remove('fsb-hidden');
    var wrap = wrapOf(el);
    if (wrap) wrap.classList.remove('fsb-wrap-hidden');
  }

  /* ---------- painting -------------------------------------------------- */

  function update(el, subtotalCents) {
    var threshold = Number(el.dataset.threshold) || 0;
    if (!threshold) {
      hide(el);
      return;
    }

    subtotalCents = Number(subtotalCents) || 0;
    el.dataset.subtotal = subtotalCents;

    if (subtotalCents <= 0) {
      hide(el);
      return;
    }
    show(el);

    var currency = el.dataset.currency;
    var progress = (subtotalCents / threshold) * 100;
    if (progress > 100) progress = 100;
    var free = subtotalCents >= threshold;

    var fill = el.querySelector('.progress');
    if (fill) fill.style.width = progress + '%';

    var msg = el.querySelector('.free-shipping-message');
    if (msg) {
      var soonAt = Number(el.dataset.soonAt) || 90;
      var copy;
      if (free) copy = el.dataset.copyDone;
      else if (progress >= soonAt) copy = el.dataset.copySoon;
      else copy = el.dataset.copyBefore;
      msg.innerHTML = withTokens(
        copy,
        free ? '' : money(threshold - subtotalCents, currency),
        el.dataset.dest
      );
      msg.classList.remove('opacity-0');
    }

    var note = el.querySelector('.fsb-note');
    if (note) {
      note.innerHTML = money(subtotalCents, currency) + ' / ' + money(threshold, currency);
    }

    paintGift(el, subtotalCents, currency);

    /* 一个 class 驱动全部「达成」变化：绿色填充、绿色卡车、图标内收、闪两下 */
    el.classList.toggle('cart_shipping_free', free);
  }

  /* ---------- the surprise marker on the track ------------------------- */

  var GIFT_FLAG = 'pas_cr_gift_popped';

  function giftFlag() {
    try { return window.sessionStorage.getItem(GIFT_FLAG) === '1'; } catch (e) { return false; }
  }
  function setGiftFlag() {
    try { window.sessionStorage.setItem(GIFT_FLAG, '1'); } catch (e) {}
  }
  function clearGiftFlag() {
    try { window.sessionStorage.removeItem(GIFT_FLAG); } catch (e) {}
  }

  function paintGift(el, subtotalCents, currency) {
    var at = Number(el.dataset.giftAt) || 0;
    if (!at) return;

    var on = subtotalCents >= at;
    var mark = el.querySelector('[data-fsb-gift]');
    var line = el.querySelector('[data-fsb-gift-note]');

    if (mark) {
      mark.classList.toggle('is-unlocked', on);
      if (on && !mark.classList.contains('is-pop')) {
        /* only pop the first time in a browsing session */
        if (!giftFlag()) {
          mark.classList.add('is-pop');
          setGiftFlag();
        }
      }
      if (!on) {
        mark.classList.remove('is-pop');
        clearGiftFlag();
      }
    }

    if (line) {
      line.innerHTML = on
        ? (el.dataset.giftCopyDone || '')
        : withTokens(el.dataset.giftCopyBefore, money(at - subtotalCents, currency), '');
      line.classList.toggle('is-unlocked', on);
      line.removeAttribute('hidden');
    }
  }

  function paint(subtotalCents) {
    var list = bars();
    for (var i = 0; i < list.length; i++) {
      update(list[i], typeof subtotalCents === 'number' ? subtotalCents : list[i].dataset.subtotal);
    }
  }

  /* ---------- keeping up with the cart --------------------------------- */

  function syncFromCart() {
    try {
      return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          paint(Number(cart.items_subtotal_price) || 0);
        })
        .catch(function () {});
    } catch (e) {
      return Promise.resolve();
    }
  }

  /* 抽屉内容是加购后局部替换的，条在它外面，所以要监听变化再同步一次小计 */
  var watching = false;

  function watchDrawer() {
    if (watching || !window.MutationObserver) return;
    var host =
      document.getElementById('minicart_wrapper') || document.querySelector('.minicart__wrapper');
    if (!host) return;
    watching = true;

    var timer = null;
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var node = records[i].target;
        if (node.closest && node.closest('free-ship-bar')) continue;
        clearTimeout(timer);
        timer = setTimeout(syncFromCart, 150);
        return;
      }
    });
    mo.observe(host, { childList: true, subtree: true, characterData: true });
  }

  window.FreeShipBar = {
    refresh: paint,
    sync: syncFromCart
  };

  /* 主题加购后可能派发的事件，能接就接一层 */
  ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (name) {
    document.addEventListener(name, function () {
      setTimeout(syncFromCart, 60);
    });
  });

  function boot() {
    paint();
    watchDrawer();
    setTimeout(syncFromCart, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
